import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import success from "../../Assets/images/success2.png";
import Button from "../SelectValue/Button";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "white",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
  maxWidth: "95%",
  outline: "none",
};

function SuccessModal({
  open,
  handleClose,
  handleViewActiveRent,
  handleViewTransaction,
  data,
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <div className="flex flex-col items-center pt-2 pb-2">
            <img src={success} alt="success" className="w-24 h-24 mb-4" />
            <h2 className="mt-2 text-[22px] font-[700] text-[#1E222B]">
              Payment successful !
            </h2>
            <p className="mt-3 text-center text-[14px] text-[#808285] leading-relaxed max-w-[90%]">
              Your rental transaction was processed securely. You're all set for
              the upcoming term.
            </p>
            <div className="mt-10 w-full flex flex-col gap-3">
              <Button
                name="View active rent"
                onClick={handleViewActiveRent}
                bool={true}
              />
              <button
                onClick={handleViewTransaction}
                className="w-full py-3.5 rounded-xl bg-[#F9FAFB] text-[#00BC67] font-[700] text-[16px] transition-colors hover:bg-gray-100"
              >
                View transcation
              </button>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default SuccessModal;
